(function(){
  if (window.__neloraProduct) return; window.__neloraProduct = true;
  function init(scope){
    (scope || document).querySelectorAll('[data-nl-gallery]').forEach(function(g){
      if (g.__nl) return; g.__nl = true;
      var slides = g.querySelectorAll('[data-nl-slide]');
      g.querySelectorAll('[data-nl-thumb]').forEach(function(t){
        t.addEventListener('click', function(){
          var id = t.getAttribute('data-nl-thumb');
          slides.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-nl-slide') === id); });
          g.querySelectorAll('[data-nl-thumb]').forEach(function(o){ o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        });
      });
    });
    (scope || document).querySelectorAll('[data-nl-form]').forEach(function(form){
      if (form.__nl) return; form.__nl = true;
      var root = form.closest('[data-nl-product]') || document;
      function update(r){
        if (!r) return;
        var p = r.getAttribute('data-price'), c = r.getAttribute('data-compare');
        root.querySelectorAll('[data-nl-price]').forEach(function(el){ el.textContent = p; });
        root.querySelectorAll('[data-nl-compare]').forEach(function(el){ el.textContent = c || ''; el.hidden = !c; });
        document.querySelectorAll('[data-nl-sticky-price]').forEach(function(el){ el.textContent = (r.getAttribute('data-title') || '') + ' · ' + p; });
      }
      form.querySelectorAll('input[name="id"][type="radio"]').forEach(function(r){
        r.addEventListener('change', function(){ update(r); });
      });
      update(form.querySelector('input[name="id"]:checked'));
    });
    var sticky = document.querySelector('[data-nl-sticky]');
    var anchor = document.querySelector('[data-nl-sticky-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window && !sticky.__nl){
      sticky.__nl = true;
      new IntersectionObserver(function(es){ es.forEach(function(e){ sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(anchor);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
